import "core-js/modules/es.object.to-string";

var Job =
/** @class */
function () {
  function Job(cb) {
    this.cb = cb;
  }
  /** cb将获得resolve和reject两个函数 */


  Job.promise = function (cb) {
    return new Job(function () {
      return new Promise(cb);
    });
  };

  Job.prototype.execute = function () {
    return this.cb();
  };

  return Job;
}();

export default Job;